import { useStaticQuery, graphql } from "gatsby";
import { formatStringToValidI18nKey } from "@app/formatters/i18n";
import { formatToShortYear } from "@app/formatters/dates";
import { ParsedPerformanceData } from "./models";

export const usePerformanceData = () => {
  const rawData = useStaticQuery(graphql`
    query PerformanceDataQuery {
      allStoryblokDatasourceEntry(
        filter: { data_source: { eq: "performance" } }
      ) {
        edges {
          node {
            value
          }
        }
      }
    }
  `);

  const data: ParsedPerformanceData = JSON.parse(
    JSON.parse(rawData.allStoryblokDatasourceEntry.edges[0].node.value),
  );

  return {
    performance: data.performance_data.map((data) => ({
      date: formatToShortYear(data["Date"]),
      alpian: data["Alpian"],
      morningstarMarkets: data["Morningstar Gbl Mkts GR CHF"],
      morningstarCore: data["Morningstar Gbl Core Bd GR Hdg CHF"],
    })),
    distribution: data.risk_profile_distribution.map((data) => ({
      volatility: data["Volatility"],
      percentage: data["Percentage of Clients"],
    })),
    statisticsTable: data.statistics_table.map((data) => ({
      statistics: formatStringToValidI18nKey(data["Statistics"]),
      alpian: data["Alpian"],
      morningstarMarkets: data["Morningstar Gbl Mkts GR CHF"],
      morningstarCore: data["Morningstar Gbl Core Bd GR Hdg CHF"],
    })),
    dateFrom: data.data_from,
    dateTo: data.data_to,
  };
};
